import AnnotationUtils from '../annotation/utils';

import { C11nEnv } from './c11n-env';
import type { AllowedComponetsForBulkProcessing } from './types';

// Singleton class as C11nEnvUtils for c11n-env.js
class C11nEnvUtils {
  static allowedComponetsForBulkProcessing: AllowedComponetsForBulkProcessing = {
    Currency: true,
    TextInput: true,
    Phone: true,
    Percentage: true,
    Email: true,
    Integer: true,
    Decimal: true,
    URL: true,
    SemanticLink: true,
    Checkbox: true,
    RadioButtons: true,
    DateTime: true,
    Date: true,
    Time: true,
    Text: true,
    TextArea: true,
    RichText: true,
    Dropdown: true,
    Search: true,
    Location: true,
    Attachment: true,
    AutoComplete: true,
    MultiSelect: true,
    UserReference: true,
    Region: true,
    TextContent: true,
    View: {
      Forms: true,
      DefaultForm: true,
      OneColumn: true,
      TwoColumn: true,
      ThreeColumn: true
    }
  };

  static getItemView(routingInfo: { accessedOrder?: any[]; items?: any[] } | undefined, renderingMode: string) {
    const viewConfigs: any[] = [];
    if (routingInfo && ['portal', 'view'].includes(renderingMode)) {
      const { accessedOrder, items } = routingInfo;
      if (accessedOrder && items) {
        const key = accessedOrder[accessedOrder.length - 1];
        if (items[key] && items[key].view && Object.keys(items[key].view).length > 0) {
          viewConfigs.push(items[key]);
        }
      }
    }
    return viewConfigs;
  }

  /**
   * it returns dependent properties for c11nEnv obj
   * @param c11nEnv c11nEnv obj
   * @returns array of dependent parameters
   * @private
   */
  static getDependentProperties = (c11nEnv: C11nEnv): any[] => {
    let dependencies: any[] = [];
    if (c11nEnv._rawConfig?.config?.parameters) {
      dependencies = Object.values(c11nEnv._rawConfig?.config?.parameters || {});
    } else if (c11nEnv.getFieldMetadata(c11nEnv.getStateProps()?.value)?.datasource?.parameters) {
      dependencies = (c11nEnv.getFieldMetadata(c11nEnv.getStateProps()?.value)?.datasource?.parameters || []).map(
        (param: any) => param?.value
      );
    }
    return dependencies
      .filter((param: any) => AnnotationUtils.isProperty(param))
      .map((param: any) => AnnotationUtils.getPropertyName(param));
  };
}

const c11EnvUtils = new C11nEnvUtils();

Object.freeze(c11EnvUtils);

export { C11nEnvUtils, c11EnvUtils };
